import React from 'react';
import { useTranslation } from 'react-i18next';
import { FigoInputMessage } from '../FigoInputMessage';

const AddPetGenderSelector = ({
  error = '',
  handleFemaleGenderSelected = () => { },
  handleMaleGenderSelected = () => { },
  noBlankSpace = false,
  maleGenderRef = null,
  petGenderSelected = {},
}) => {
  const { t } = useTranslation('quoting');
  const describedbyId = 'gender-selector-message';
  return (
    <div className="Modal-add-pet-gender-selector-wrapper">
      <span className="Modal-add-pet-gender-selector-title">
        {t('petForm.petGender')}
      </span>

      <div className="Modal-add-pet-gender-selector">
        <button
          ref={maleGenderRef}
          aria-describedby={describedbyId}
          aria-label={petGenderSelected.maleGender.label}
          aria-live={petGenderSelected.maleGender.selected
            ? 'assertive' : 'off'}
          className={'Modal-add-pet-gender-selector-item '
            + `${petGenderSelected.maleGender.className}`}
          id="modalAddPetMaleSelector"
          onClick={handleMaleGenderSelected}
          type="button"
        >
          {t('petForm.male')}
        </button>

        <button
          aria-describedby={describedbyId}
          aria-label={petGenderSelected.femaleGender.label}
          aria-live={petGenderSelected.maleGender.selected
            ? 'assertive' : 'off'}
          className={'Modal-add-pet-gender-selector-item '
            + `${petGenderSelected.femaleGender.className}`}
          id="modalAddPetFemaleSelector"
          onClick={handleFemaleGenderSelected}
          type="button"
        >
          {t('petForm.female')}
        </button>
      </div>

      <FigoInputMessage
        id={describedbyId}
        message={error}
        noBlankSpace={noBlankSpace}
      />
    </div>
  );
};

export { AddPetGenderSelector };
